import { RiPanelConstants } from "../../Constants/RiPanelConstants";

const { ActionTypes } = RiPanelConstants;

export const showZZIndicatorEditDialog = (isShowZZIndicatorEditDialog = true, isSave = false) => ({
    type: ActionTypes.SHOW_ZZ_INDICATOR_EDIT_DIALOG,
    isShowZZIndicatorEditDialog, isSave
});


export const getAiStatisticsData = (symbol, periodicity, graphType, beginDate, endDate) => ({
    type: ActionTypes.GET_AI_STATISTIC_DATA,
    symbol, periodicity, graphType, beginDate, endDate
});